exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.image-item {\r\n  width: 100%;\r\n  height: 600px;\r\n}\r\n\r\n.items-container {\r\n  margin-top: 25px;\r\n}\r\n\r\n/* Large desktops and laptops */\r\n\r\n@media (min-width: 1200px) {\r\n\r\n}\r\n\r\n/* Landscape tablets and medium desktops */\r\n\r\n@media (min-width: 992px) and (max-width: 1199px) {\r\n\r\n}\r\n\r\n/* Portrait tablets and small desktops */\r\n\r\n@media (min-width: 768px) and (max-width: 991px) {\r\n\r\n}\r\n\r\n/* Landscape phones and portrait tablets */\r\n\r\n@media (max-width: 767px) {\r\n\r\n}\r\n\r\n/* Portrait phones and smaller */\r\n\r\n@media (max-width: 480px) {\r\n\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/app/shared/components/image-slider/image-slider.component.css
// module id = ../../../../../src/app/shared/components/image-slider/image-slider.component.css
// module chunks = main